import { combineReducers } from 'redux';
import loginReducer from '../../auth/reducers/login.reducer';
import registerReducer from  '../../auth/reducers/register.reducer';
import verifyReducer from '../../auth/reducers/verify.reducer';
import userManagementReducer from '../../technicians/reducers/userManagement.reducer';
import toastReducer from './toaster.reducer';
import profileReducer from '../../profile/reducers/profile.reducer';
import applicationReducer from '../../auth/reducers/application.reducer';
import jobsReducer from '../../jobs/reducers';
import journeyReducer from '../../customization/reducers/journey.reducer';
import modalReducer from './modal.reducer';
import insightsReducer from '../../insights/reducers/insights.reducer';
import billingReducer from './billing.reducer';
import orgHierarchyReducer from './orgHierarchy.reducer';
import { LoginActions } from '../../auth/actions';
import restoreReducer from '../../auth/reducers/restore.reducer';
import chatReducer from '../../chat/reducers/chat.reducer';
import sessionsReducer from '../../jobs/reducers/sessions.reducer';
import internalSignUpReducer from '../../i-admin/reducers/internalSignUp.reducer';

const appReducer = combineReducers({
  profile: profileReducer,
  login: loginReducer,
  restore: restoreReducer,
  userManagement: userManagementReducer,
  toasts: toastReducer,
  jobs: jobsReducer,
  orgManagement: combineReducers({
    register: registerReducer,
    verify: verifyReducer,
    application: applicationReducer,
  }),
  orgHierarchy: orgHierarchyReducer,
  journey: combineReducers({
    config: journeyReducer,
  }),
  modal: modalReducer,
  insights: insightsReducer,
  billing: billingReducer,
  chat: chatReducer,
  sessions: sessionsReducer,
  internalSignUp: internalSignUpReducer,
});

const rootReducer = (state, action) => {
  if (action.type === LoginActions.LogoutSuccess) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
